import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getCompany(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams);
}

export async function createCompany(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/company" + pathname, body);
}

export async function updateCompany(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/company" + pathname, body);
}

export async function deleteCompany(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).delete("/company" + pathname, { data: body });
}
